module.exports = __webpack_public_path__ + "5996369566a565d77e1267f99649586f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_80.jpg
// module id = 1791
// module chunks = 5